/**
 * __ShapeDiver 3D Viewer Application__, copyright (c) 2018 _ShapeDiver GmbH_
 *
 * *main_reflector.js*
 *
 * ### Content
 *   * everything that should be exported from the reflector build
 *
 */

(function() {
  // get the constructor of the reflector
  var REFLECTOR = require('../src/api/v2/ApiReflectorV2.1');
  var GLOBAL_UTILS = require('../src/shared/util/GlobalUtils');
  // we initialize the reflector upon receiving the first message from the iframe
  var init_reflector = function(event) {
    // we ignore all messages except the ones from the ShapeDiver iframe
    var iframe = document.getElementById('sdv-iframe');
    if (!iframe) iframe = document.getElementById('sdv-frame');
    if (iframe && iframe.src && iframe.src.indexOf(event.origin) === 0) {
      // we de-register ourselves
      window.removeEventListener('message', init_reflector, false);
      // instantiate the reflector, who will set up it's own event listener
      if (!window.SDVReflector) {
        // should we instantiate the reflector in debug mode?
        var debug = GLOBAL_UTILS.getNodeAttribute(iframe, 'debug', false);
        // instantiate reflector
        window.SDVReflector = new REFLECTOR(iframe.contentWindow, event.origin, !!debug);
      }
      // process the message in the reflector
      window.SDVReflector.receiveMessage(event);
    }
  };
  window.addEventListener('message', init_reflector, false);
})();
